import { hideLoading, htmlToElement, showLoading } from '../components/utils.js';
import { generatePaginationButtons, generatePaginationLabel } from '../components/pagination';
import { trackAppliedFiltersCatalogs } from '../analytics/cms.js';

(function () {
	const catalogsForm = document.querySelector('.m-search__catalog-literature-form');
	const clearSearchForm = document.querySelector('.m-search__form-clear-btn');

	if (!catalogsForm) {
		return;
	}

	window._timken.userProjects = []; // initialize empty list of projects

	/**
	 * Dynamic import of a React component
	 * This prevents 'Uncaught SyntaxError: Cannot use import statement outside a module'
	 * as the module is importing this component from a different chunk
	 */
	const initializeReactSaveDocument = async () => {
		const mod = await import('../my-dashboard/save-to-project/document');
		await mod.refreshProjects(); // optional
		mod.initializeReactSaveDocumentToProject();
	};

	const handleAccountInfoLoaded = async () => {
		// dynamic import of  sso/index.js
		const { getIdToken } = await import('../sso/index.js');
		const timkenIdToken = await getIdToken();

		if (timkenIdToken) {
			initializeReactSaveDocument();
		}
	};

	document.addEventListener('timken_sso_account_info_loaded', handleAccountInfoLoaded);

	catalogsForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		trackAppliedFiltersCatalogs(catalogsForm);
		await doCatalogSearch();
	});

	if (clearSearchForm) {
		clearSearchForm.addEventListener('click', async (e) => {
			e.preventDefault();
			const filtersCheckboxes = catalogsForm.querySelectorAll('input[type="checkbox"]');
			if (!filtersCheckboxes) {
				return;
			}
			for (const filtersCheckbox of filtersCheckboxes) {
				filtersCheckbox.checked = false;
			}
			await doCatalogSearch();
		});
	}

	const doCatalogSearch = async (pageNumber = 1) => {
		showLoading();
		const formData = new FormData(catalogsForm);
		const keyword = formData.get('keyword') ?? '';
		const filterFields = [...new Set(Array.from(formData.keys()))];
		const filtersObject = {};

		for (const filterField of filterFields) {
			if (filterField !== 'keyword') {
				filtersObject[filterField] = formData.getAll(filterField);
			}
		}

		const rawResponse = await fetch(
			'/wp-json/timken-search/v1/literature',
			{
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					s: keyword,
					page: pageNumber,
					filters: filtersObject,
				}),
			},
		);
		const catalogResult = await rawResponse.json();
		const totalItems = catalogResult.total || 0;
		const pageSize = catalogResult.posts_per_page || 0;
		const paginationLabel = catalogsForm.closest('.m-search').querySelector('.m-filtered-grid__pagination-label');
		const paginationWrapper = catalogsForm.closest('.m-search').querySelector(
			'.m-search__result-pagination',
		);

		if (totalItems > 0) {
			paginationLabel.innerHTML = generatePaginationLabel(
				pageNumber,
				pageSize,
				totalItems,
			);

			generatePaginationButtons(
				pageSize,
				pageNumber,
				totalItems,
				paginationWrapper,
				doCatalogSearch,
			);
		} else {
			paginationLabel.innerHTML = '';
			paginationWrapper.innerHTML = '';
		}

		populateCatalogData(catalogResult.posts, totalItems);
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
		hideLoading();
	};

	const populateCatalogData = (catalogResult, totalItems) => {
		const searchWrapper = catalogsForm.closest('.m-search');
		const resultWrapper = searchWrapper.querySelector('.js-catalogs-literature-results');
		const noResultWrapper = searchWrapper.querySelector('.js-catalogs-literature-no-results');

		resultWrapper.innerHTML = '';

		if (catalogResult && catalogResult.length > 0) {
			noResultWrapper.classList.add('d-none');

			catalogResult.forEach((c) => {
				const catalogEntry = `
					<div class="m-filtered-grid__result-entry m-container--enforce-rounded-image
							m-container--bg-color-light-blue m-container--rounded-borders">
						${c.thumbnail ? `
							<a class="m-filtered-grid__entry-link--${c.post_type}" target="_blank" href="${c.url}">
								<figure class="m-filtered-grid__entry-image">
									<img src="${c.thumbnail}"
										alt="${c.post_title_strip} cover image">
								</figure>
							</a>
						` : ''}
						<a class="m-filtered-grid__entry-link--${c.post_type}" target="_blank" href="${c.url}">
							<h4 class="m-filtered-grid__entry-title">${c.post_title}</h4>
						</a>
						<p class="m-filtered-grid__entry-excerpt">${c.excerpt}</p>
						<div class="document-actions-container">
							<div class="timken-save-document-to-project" data-doc-url="${c.url}" data-doc-name="${c.post_title_strip}">
							<button
								class="btn btn--tertiary dropdown-toggle document-action"
								type="button"
								disabled
							>
								<i class="document-action__icon icon-lock"></i> <span class="document-action__text">Save</span>
							</button>
							</div>
							<a class="btn m-cta__link btn--tertiary m-filtered-grid__entry-link--${c.post_type} document-action"
							target="_blank" href="${c.download_url}"  cta-type="btn--tertiary" cta-icon="" download>
								<i class="document-action__icon icon-download"></i> <span class="document-action__text">Download</span>
							</a>
						</div>
					</div>
				`;

				resultWrapper.appendChild(htmlToElement(catalogEntry));
			});

			handleAccountInfoLoaded();

		} else {
			noResultWrapper.classList.remove('d-none');
		}

		if (window.searchTerm) {
			const inputSearch = catalogsForm.querySelector('.js-catalog-search-input');
			let searchTermInput = inputSearch.value || window.searchTerm;

			window.dataLayer.push({
				event: "site_search_output",
				eng_results_category: "Catalogs & Literature",
				successful_search: catalogResult && catalogResult.length > 0,
				num_of_results: totalItems,
				search_term: searchTermInput
			});
		}
	};

	if (window.searchTerm) {
		const inputSearch = catalogsForm.querySelector('.js-catalog-search-input');
		inputSearch.value = window.searchTerm;
	} else {
		const defaultLanguage = catalogsForm.querySelector('input[name="language"][value="English"]');
		if (defaultLanguage) {
			defaultLanguage.checked = true;
		}
	}

	doCatalogSearch().then();
}());
